import { Component } from '@angular/core';
import { HistoryUrlService } from './shared/services/history-url.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {

  constructor(
    private historyUrlService: HistoryUrlService
  ) {
    this.historyUrlService.addNewUrl()
  }
}
